import React, { useState } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation, Navigate } from 'react-router-dom';
import Header from './components/Header';
import PortraitHeader from './components/PortraitHeader';
import Footer from './components/Footer';

import Verhaal from './pages/nl/Verhaal';
import Privacy from './pages/nl/PrivacyStatement';
import Home from './pages/nl/Home';
import Colofon from './pages/nl/Colofon';
import Links from './pages/nl/Links';
import Docu from './pages/nl/Docu';
import NotFound from './pages/404';
import Portrait from './pages/nl/Portrait';
import Onderzoek from './pages/nl/Onderzoek';

import StoryEN from './pages/en/Story';
import PortraitEN from './pages/en/Portrait';
import PrivacyEN from './pages/en/PrivacyStatement';
import HomeEN from './pages/en/Home';
import ColophonEN from './pages/en/Colophon';
import LinksEN from './pages/en/Links';
import DocuEN from './pages/en/Docu';
import ResearchEN from './pages/en/Research';

import { Analytics } from "@vercel/analytics/react";

function App() {
  return (
    <Router>
      <AppContent />
      <Analytics />
    </Router>
  );
}

function AppContent() {
  const [menuOpen, setMenuOpen] = useState(false);
  const location = useLocation();

  const isPortraitPage =
  location.pathname === "/en/artworks" ||
  location.pathname === "/nl/kunstwerken";

  return (
    <div className="min-h-screen flex flex-col">

{/* 🎨 HEADER LOGIC */}
{!isPortraitPage && <Header setMenuOpen={setMenuOpen} />}

{/*       {isPortraitPage ? (
        <PortraitHeader />
      ) : (
        <Header setMenuOpen={setMenuOpen} />
      )} */}

      {/* MAIN CONTENT */}
      <main className="flex-grow w-full p-0">
        <Routes>
        <Route path="/" element={<Navigate to="/nl" replace />} />
        

          {/* DUTCH */}
          <Route path="/nl" element={<Home />} />
          <Route path="/nl/verhaal" element={<Verhaal />} />
          <Route path="/nl/privacystatement" element={<Privacy />} />
          <Route path="/nl/kunstwerken" element={<Portrait />} />
          <Route path="/nl/links" element={<Links />} />
          <Route path="/nl/colofon" element={<Colofon />} />
          <Route path="/nl/docu" element={<Docu />} />
          <Route path="/nl/onderzoek" element={<Onderzoek />} />

          {/* ENGLISH */}
          <Route path="/en" element={<HomeEN />} />
          <Route path="/en/story" element={<StoryEN />} />
          <Route path="/en/privacystatement" element={<PrivacyEN />} />
          <Route path="/en/artworks" element={<PortraitEN />} />
          <Route path="/en/links" element={<LinksEN />} />
          <Route path="/en/colophon" element={<ColophonEN />} />
          <Route path="/en/docu" element={<DocuEN />} />
          <Route path="/en/research" element={<ResearchEN />} />


          <Route path="*" element={<NotFound />} />
        </Routes>
      </main>

      {/* FOOTER (optional: change if you want a different footer too) */}
      <Footer />
    </div>
  );
}

export default App;
